import { IconBase, IconBaseProps } from 'react-icons';

export function MapMarkerIcon(props: IconBaseProps) {
    return (
        <IconBase id="MapMarkerIcon" {...props} viewBox="0 0 39 44" data-testid="MapMarkerIcon">
            <path
                fill="currentColor"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M32.26 32.26h0a18.311 18.311 0 1 0-25.897 0h0l9.184 9.181h0a5.328 5.328 0 0 0 7.531 0h0l9.182-9.182Zm-7.456-12.95a5.492 5.492 0 1 1-10.984 0 5.492 5.492 0 0 1 10.984 0Z"
            />
        </IconBase>
    );
}
